/* eslint-disable react/no-unescaped-entities */
import { icCda } from '@/components/GenericsTournaments/Icons/';

export const InfoContent = () => {
  return (
    <div className="text-left">
      <h6 className="lg:text-center lg:text-base text-sm font-bold text-gdt-blue-header flex lg:items-center max-sm:max-w-[250px]">
        <figure className="min-w-8">
          <img alt="Icono de copa" src={icCda} />
        </figure>
        <span className="ps-2">
          ¿Qué es la Copa de Amigos y cómo participar?
        </span>
      </h6>
      <p className="lg:mt-7 mt-5">
        La Copa de Amigos es una competencia especial en la que los
        participantes que tengan armado su equipo de Primera, podrán
        <span className="font-semibold">
          {' '}
          armar un "equipo" con 3 amigos más y competir contra otros "equipos".
        </span>
        <br />
        <br />
        Cada equipo estará formado por cuatro DT's. Uno será el administrador,
        que es quien crea el equipo, le pone un nombre e invita a sus amigos a
        participar. El equipo quedará activo una vez que se complete con los 4
        participantes y competirá contra otros equipos.
      </p>
    </div>
  );
};
